//@flow
import {
  createSingleFieldFormData,
  createMultiFieldFormData,
} from '../../../utils/form';
import {
  uploadImageStoreApi,
  uploadFileStoreApi,
  makeEphemeralFilesApi,
} from '../api';
import {compressImageIfNecessary} from '../../../utils/image';

import type {StoredFile} from '../../../entities';
import type {CompressImageIfNecessaryParams} from '../../../utils/image';

type UploadImageServiceParams = {
  temp?: boolean,
};

export function uploadImageService(
  payload: File | File[] | Blob | Blob[],
  prefix: string,
  params?: UploadImageServiceParams
): Promise<StoredFile[]> {
  const formData = Array.isArray(payload)
    ? createMultiFieldFormData(payload, undefined, {
        filePrefix: prefix,
      })
    : createSingleFieldFormData(payload, undefined, {
        filePrefix: prefix,
      });
  const queryParams = {};
  if (params?.temp) {
    queryParams.temp = '1';
  }

  return uploadImageStoreApi(formData, {
    queryParams,
  }).toPromise();
}

export type ResourceTypes =
  | 'XLSX'
  | 'PDF'
  | 'IMAGE'
  | 'HTML'
  | 'AUDIO'
  | 'VIDEO';
export async function processAndUploadImage(
  file: File,
  prefix: string,
  options?: {
    compressParams?: CompressImageIfNecessaryParams,
    uploadParams?: UploadImageServiceParams,
  }
): Promise<StoredFile[]> {
  const processedFile = options?.compressParams
    ? await compressImageIfNecessary(file, options.compressParams)
    : file;
  return uploadImageService(processedFile, prefix, options?.uploadParams);
}

export type UploadFileServiceParams = {
  filePrefix: string,
  resourceType: ResourceTypes,
  temp?: boolean,
};

export function uploadFileService(
  file: File | Blob,
  params: UploadFileServiceParams
): Promise<StoredFile[]> {
  const {filePrefix, resourceType, temp} = params;

  const additionalData: any = {
    filePrefix,
    temp: temp ? '1' : '0',
  };

  if (resourceType) {
    additionalData.resourceType = resourceType;
  }

  const formData = createSingleFieldFormData(file, undefined, additionalData);

  return uploadFileStoreApi(formData).toPromise();
}

export async function makeEphemeralFilesService(fileIds: string[]) {
  return makeEphemeralFilesApi({fileIds}).toPromise();
}
